import { extendTheme } from '@chakra-ui/react';

export const customTheme = extendTheme({
  fonts: {
    heading: "'Public Sans', sans-serif",
    body: "'Public Sans', sans-serif",
  },
});
